import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 8v-1h-6v1","key":"svg-0"}],["path",{"d":"M6 15v-8","key":"svg-1"}],["path",{"d":"M21 15l-5 -8","key":"svg-2"}],["path",{"d":"M16 15l5 -8","key":"svg-3"}],["path",{"d":"M14 11h-4v8h4","key":"svg-4"}],["path",{"d":"M10 15h3","key":"svg-5"}]]

const IconTex = createReactComponent('outline', 'tex', 'Tex', __iconNode);

export default IconTex;